/**
 * Scroll-into-view reveal helper for [data-ws-sfr] roots.
 * See docs/storefront-scroll-reveal-requirements.md
 */
(function () {
  'use strict';

  var rootEl = document.documentElement;
  if (!rootEl.classList.contains('ws-sfr-enable')) return;

  if (typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var supportsVt =
    rootEl.classList.contains('ws-sfr-vt') &&
    typeof window.CSS !== 'undefined' &&
    typeof CSS.supports === 'function' &&
    CSS.supports('animation-timeline: view()');

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-ws-sfr]'));
  if (!roots.length) return;

  if (typeof IntersectionObserver === 'undefined') {
    roots.forEach(function (el) {
      el.classList.add('ws-sfr--visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('ws-sfr--visible');
        obs.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -4% 0px', threshold: 0 }
  );

  for (var j = 0; j < roots.length; j++) {
    var node = roots[j];
    var preset = node.getAttribute('data-ws-sfr');

    /* timeline handles rise_soft / drift in Chromium; cascades stay on IO */
    if (supportsVt && (preset === 'rise_soft' || preset === 'drift')) continue;

    observer.observe(node);
  }
})();
